import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import type { CSSProperties } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';
import { COLORS_MAP } from '../constants';
import type { ColorToken, SpacingToken } from '../types';
import { wellSpacingClass } from './constants';
import { getSpacingVars } from './utils';

export type WellProps = StructuredContentDocument<{
  margin?: SpacingToken;
  padding?: SpacingToken;
  marginTop?: SpacingToken;
  marginBottom?: SpacingToken;
  marginLeft?: SpacingToken;
  marginRight?: SpacingToken;
  paddingTop?: SpacingToken;
  paddingBottom?: SpacingToken;
  paddingLeft?: SpacingToken;
  paddingRight?: SpacingToken;
  backgroundColor?: ColorToken;
  color?: ColorToken;
  children: StructuredContentDocument;
  rendererProps?: RendererProps;
}>;

export const Well = ({ props }: WellProps) => {
  const { children, color, backgroundColor, rendererProps, ...spacingProps } = props;

  const spacingVars = getSpacingVars(spacingProps);

  const containerColor = backgroundColor ?? color;

  return (
    <div
      className={wellSpacingClass}
      style={
        {
          backgroundColor: COLORS_MAP[containerColor ?? 'green-lighter'],
          ...spacingVars,
        } as CSSProperties
      }
    >
      {renderStructuredContent(children, rendererProps)}
    </div>
  );
};
